export default "/images/photos-trio-2.png?577ae2cb4082e288a6845583040b519f";